import ToastStatusEnum from "../constants/ToastStatusEnum";
import * as ToastsAction from "../stores/toasts/ToastsAction";
import { ActionsWithoutErrorToast } from "../stores/error/ActionsWithoutErrorToast";

export default function errorToastMiddleware() {
    return store => next => action => {
        if (action.error) {
            if (!ActionsWithoutErrorToast.find(a => a === action.type))
            {
                const errorAction = action;
                next(ToastsAction.add("Status " + errorAction.payload.status, errorAction.payload.message, ToastStatusEnum.Error));
            }
        }
        next(action);
    };
}
